module.exports = __webpack_public_path__ + "static/img/penny.ce47a89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haibao_vx/penny.png
// module id = WXbX
// module chunks = 0